import { render } from "./CreateShipment.vue?vue&type=template&id=02820692"
import script from "./CreateShipment.vue?vue&type=script&lang=js"
export * from "./CreateShipment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__